import type { GoOfflineConfig, GoOfflineController, OfflineStatusSnapshot } from "../types";
import { createController } from "./controller";
import { createLogger } from "./logger";
import { getOfflineSnapshot, subscribeToOfflineStatus } from "./offline-status";
import { initPWAInstallTracking } from "./pwa-install";
import { registerServiceWorker } from "./register-service-worker";
import { normalizeConfig } from "../utils/normalize-config";

export async function setupOffline(configInput: GoOfflineConfig = {}): Promise<GoOfflineController> {
  const config = normalizeConfig(configInput);
  const logger = createLogger(config.debug);

  let currentSnapshot: OfflineStatusSnapshot = getOfflineSnapshot();

  const unsubscribe = subscribeToOfflineStatus((snapshot) => {
    const wasOnline = currentSnapshot.isOnline;
    currentSnapshot = snapshot;

    if (wasOnline !== snapshot.isOnline) {
      if (snapshot.isOnline) {
        config.callbacks.onOnline?.();
      } else {
        config.callbacks.onOffline?.();
      }

      logger.debug("Connectivity changed.", snapshot);
    }
  });

  if (config.pwa) {
    initPWAInstallTracking();
  }

  const { registration } = await registerServiceWorker(config);

  return createController(registration, unsubscribe);
}
